import { Column } from "primereact/column";
import { DataTable, type DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { useCallback } from "react";
import { useTranslation } from "@i18n/hooks";
import { dataTableClass, emptyMessageClass } from "./single-selection-data-table.styles";
import { SingleSelectionDataTableProps } from "./single-selection-data-table.types";

export const SingleSelectionDataTable = ({
	selectedUserId,
	values,
	onSelectionChange,
}: SingleSelectionDataTableProps) => {
	const { t } = useTranslation("common");
	const handleSelection = useCallback(
		(event: DataTableSelectionSingleChangeEvent<any>) => {
			onSelectionChange(event);
		},
		[onSelectionChange],
	);

	return (
		<DataTable
			emptyMessage={
				<div className="flex justify-content-center align-items-center">
					<div className={emptyMessageClass}>{t("user.noUserFound")}</div>
				</div>
			}
			className={dataTableClass}
			selectionMode={"single"}
			selection={{ node: { id: selectedUserId } }}
			dataKey="node.id"
			onSelectionChange={handleSelection}
			value={values ?? []}
		>
			<Column header={t("table.name")} field="node.name" />
			<Column header={t("table.email")} field="node.email" />
			<Column
				header={t("table.activated")}
				body={(user) => {
					return user?.node?.activated ? t("user.activated") : t("user.notActivated");
				}}
			/>
		</DataTable>
	);
};
